export default {
  darker: "#1e272e",
  dark: "#40474c",
  light: "#d2dae2",
  primary: "#485460",
};
